import doubleDials from "../../../../components/doubleDials/doubleDials";
import { connect } from "react-redux";
export default connect(state => ({
  currentData: [
    {
      name: "Current",
      value:
        state.followUp.membershipUpgradesToday.contactedMembershipUpgrades !== 0
          ? Math.round(
              (state.followUp.membershipUpgradesToday.contactedMembershipUpgrades /
                (state.followUp.membershipUpgradesToday.notContactedMembershipUpgrades + state.followUp.membershipUpgradesToday.contactedMembershipUpgrades)) *
                100
            )
          : 0
    },
    {
      name: "Remain",
      value:
        state.followUp.membershipUpgradesToday.contactedMembershipUpgrades !== 0
          ? 100 -
            Math.round(
              (state.followUp.membershipUpgradesToday.contactedMembershipUpgrades /
                (state.followUp.membershipUpgradesToday.notContactedMembershipUpgrades + state.followUp.membershipUpgradesToday.contactedMembershipUpgrades)) *
                100
            )
          : 100
    }
  ],
  pacingData: [
    {
      name: "Pacing",
      value:
        state.followUp.membershipUpgradesToday.notContactedMembershipUpgrades !== 0
          ? Math.round(
              (state.followUp.membershipUpgradesToday.notContactedMembershipUpgrades /
                (state.followUp.membershipUpgradesToday.notContactedMembershipUpgrades + state.followUp.membershipUpgradesToday.contactedMembershipUpgrades)) *
                100
            )
          : 0
    },
    {
      name: "Remain",
      value:
        state.followUp.membershipUpgradesToday.notContactedMembershipUpgrades !== 0
          ? 100 -
            Math.round(
              (state.followUp.membershipUpgradesToday.notContactedMembershipUpgrades /
                (state.followUp.membershipUpgradesToday.notContactedMembershipUpgrades + state.followUp.membershipUpgradesToday.contactedMembershipUpgrades)) *
                100
            )
          : 100
    }
  ]
}))(doubleDials);
